import {Typography} from '@mui/material';
import CalendarBoardGrid from './CalendarBoardGrid';
import CalendarBoardItem from './CalendarBoardItem';
import IDay from './IDay';
import {getEventsOf} from './IEvent';

interface IProps {
	date: Date;
	setDate: (day: Date) => void;
}

export default function CalendarBoard({date, setDate}: IProps) {
	const firstDay = new Date(date);
	
	// @ts-ignore getting frist day of jalali month
	firstDay.setDate(firstDay.getDate() + 1 - Number(firstDay.toLocaleDateString('fa-IR', {day: 'numeric'}).replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))));
	// getting first day of jalali week in this week
	if (firstDay.getDay() < 6) {
		firstDay.setDate(firstDay.getDate() - firstDay.getDay() - 1);
	}
	
	const days: IDay[] = Array.from({length: 35}, (_, i) => {
		const d = new Date(firstDay);
		firstDay.setDate(firstDay.getDate() + 1);
		return {
			isHoliday: d.getDay() === 5 || getEventsOf(d).some(event => event.isHoliday),
			isSelected: d.toLocaleDateString() === date.toLocaleDateString(),
			isToday: d.toLocaleDateString() === new Date().toLocaleDateString(),
			isDisabled: d.toLocaleDateString('fa-IR', {month: 'numeric'}) !== date.toLocaleDateString('fa-IR', {month: 'numeric'}),
			date: d,
			hijriDate: firstDay,
			setDate: () => {
				setDate(d);
			}
		};
	});
	
	return (
		<div className="mx-4 flex flex-col">
			<div className="mb-4 flex flex-row text-center">
				<Typography sx={{color: 'grey.500', fontSize: (theme) => theme.typography.fontSize - 2}}
				            className="grow">ش</Typography>
				<Typography sx={{color: 'grey.500', fontSize: (theme) => theme.typography.fontSize - 2}}
				            className="grow">ی</Typography>
				<Typography sx={{color: 'grey.500', fontSize: (theme) => theme.typography.fontSize - 2}}
				            className="grow">د</Typography>
				<Typography sx={{color: 'grey.500', fontSize: (theme) => theme.typography.fontSize - 2}}
				            className="grow">س</Typography>
				<Typography sx={{color: 'grey.500', fontSize: (theme) => theme.typography.fontSize - 2}}
				            className="grow">چ</Typography>
				<Typography sx={{color: 'grey.500', fontSize: (theme) => theme.typography.fontSize - 2}}
				            className="grow">پ</Typography>
				<Typography sx={{color: 'grey.500', fontSize: (theme) => theme.typography.fontSize - 2}}
				            className="grow">ج</Typography>
			</div>
			<CalendarBoardGrid>
				{
					days.map(day => <CalendarBoardItem key={day.date.toDateString()} day={day}/>)
				}
			</CalendarBoardGrid>
		</div>
	);
}
